import { PageListDataSource } from './BaseDataSources';
import { IUnmatchedLoansResult } from '../Interfaces';

export class UnmatchedLoansSource extends PageListDataSource<IUnmatchedLoansResult> {
  public constructor() {
    super('/datasource/importdetails/notfoundloans', {}, 100);
  }
}